import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import MatCheckbox from '@material-ui/core/Checkbox';

const Checkbox = (props) => {
    return (
        <FormControlLabel
            control={<MatCheckbox {...props} />}
            label={props.label} />
    );
}

export default Checkbox;
